import { createIcon } from '@chakra-ui/react'

export const SearchIcon = createIcon({
  displayName: 'SearchIcon',
  viewBox: '0 0 13 13',
  path: (
    <svg width="13" height="13" fill="none">
      <circle cx="4.8" cy="4.8" r="3.9" stroke="black" strokeWidth="1.8" />
      <path
        d="M11.3636 12.6363C11.715 12.9878 12.2849 12.9878 12.6363 12.6363C12.9878 12.2849 12.9878 11.715 12.6363 11.3636L11.3636 12.6363ZM6.56356 7.83635L11.3636 12.6363L12.6363 11.3636L7.83635 6.56356L6.56356 7.83635Z"
        fill="black"
      />
    </svg>
  ),
})
